import { useUIStore } from '@/stores/ui'
import { useSidebarOffset } from '@/hooks/useSidebarOffset'

const typeStyles: Record<string, string> = {
  success: 'border border-success-200 bg-success-50 text-success-800',
  error: 'border border-danger-200 bg-danger-50 text-danger-800',
  warning: 'border border-warning-200 bg-warning-50 text-warning-800',
  info: 'border border-beacon-200 bg-beacon-50 text-beacon-800',
}

const typeIcons: Record<string, string> = {
  success: 'fa-circle-check',
  error: 'fa-circle-xmark',
  warning: 'fa-triangle-exclamation',
  info: 'fa-circle-info',
}

export function AppToasts() {
  const toasts = useUIStore((s) => s.toasts)
  const dismissToast = useUIStore((s) => s.dismissToast)
  const sidebarOffset = useSidebarOffset()

  if (toasts.length === 0) return null

  return (
    <div
      className="fixed bottom-24 z-[200] flex flex-col items-center gap-2 pointer-events-none transition-[left] duration-300"
      style={{ left: `calc(50% + ${sidebarOffset}px)`, transform: 'translateX(-50%)' }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-start gap-2 px-4 py-2.5 rounded-lg shadow-lg text-sm font-semibold pointer-events-auto max-w-[min(384px,calc(100vw-2rem))] ${typeStyles[toast.type] ?? typeStyles.info}`}
        >
          <i className={`fa-solid ${typeIcons[toast.type] ?? typeIcons.info} text-xs flex-shrink-0`} />
          <span>{toast.message}</span>
          <button
            onClick={() => dismissToast(toast.id)}
            className="ml-1 opacity-70 hover:opacity-100 flex-shrink-0"
          >
            <i className="fa-solid fa-xmark text-xs" />
          </button>
        </div>
      ))}
    </div>
  )
}
